import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
/**
 * Wrap state around story components.
 *
 * Example:
 * <StateWrapper initialState={{activeThing: 1}}>
 *   {(state, setState) => (
 *     <div>
 *       {state.activeThing === 1 && <div>Thing 1</div>}
 *       {state.activeThing === 2 && <div>Thing 2</div>}
 *     </div>
 *   )}
 *  </StateWrapper>
 */

export var StateWrapper = /*#__PURE__*/function (_Component) {
  _inherits(StateWrapper, _Component);

  var _super = _createSuper(StateWrapper);

  function StateWrapper() {
    var _this;

    _classCallCheck(this, StateWrapper);

    _this = _super.apply(this, arguments);

    _this.setStateFunc = function (prevState, props) {
      return _this.setState(prevState, props);
    };

    return _this;
  }

  _createClass(StateWrapper, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState(this.props.initialState);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state, this.setStateFunc);
    }
  }]);

  return StateWrapper;
}(Component);